export default __webpack_public_path__ + "static/heartopener_2-d5e36c71296bd7cd307d61b6f2a81ca9.jpg";